"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TenantProvider = exports.TenantIds = void 0;

var _tenant_id_pb = require("../proto/spine/core/tenant_id_pb");

var _email_address_pb = require("../proto/spine/net/email_address_pb");

var _internet_domain_pb = require("../proto/spine/net/internet_domain_pb");

var _typedMessage = require("./typed-message");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * A factory of `TenantId` instances.
 *
 * Exposes methods that are "shortcuts" for the convenient creation of `TenantId` message
 * instances.
 */
var TenantIds = /*#__PURE__*/function () {
  function TenantIds() {
    _classCallCheck(this, TenantIds);
  }

  _createClass(TenantIds, null, [{
    key: "internetDomain",
    value:
    /**
     * Constructs a `TenantId` which represents an internet domain.
     *
     * @param {!string} domainName the domain name as a plain string
     * @return {TenantId} a new `TenantId` instance
     */
    function internetDomain(domainName) {
      if (!domainName) {
        throw new Error('Expected a non-empty internet domain name.');
      }

      var domain = new _internet_domain_pb.InternetDomain();
      domain.setValue(domainName);
      var result = new _tenant_id_pb.TenantId();
      result.setDomain(domain);
      return result;
    }
    /**
     * Constructs a `TenantId` which represents an email address.
     *
     * @param {!string} address the email address as a plain string
     * @return {TenantId} a new `TenantId` instance
     */

  }, {
    key: "emailAddress",
    value: function emailAddress(address) {
      if (!address) {
        throw new Error('Expected a non-empty email address value.');
      }

      var emailAddress = new _email_address_pb.EmailAddress();
      emailAddress.setValue(address);
      var result = new _tenant_id_pb.TenantId();
      result.setEmail(emailAddress);
      return result;
    }
    /**
     * Constructs a `TenantId` which is a plain string value.
     *
     * @param {!string} tenantIdValue the tenant ID
     * @return {TenantId} a new `TenantId` instance
     */

  }, {
    key: "plainString",
    value: function plainString(tenantIdValue) {
      if (!tenantIdValue) {
        throw new Error('Expected a valid tenant ID value.');
      }

      var result = new _tenant_id_pb.TenantId();
      result.setValue(tenantIdValue);
      return result;
    }
  }]);

  return TenantIds;
}();
/**
 * The current tenant provider.
 *
 * This object is passed to the `ActorRequestFactory` and is used during creation of all
 * client-side requests.
 *
 * The current tenant ID can be switched dynamically with the help of the `update` method.
 *
 * If it is necessary to update the current ID to a "no tenant" value (to work in a single-tenant
 * environment), pass the default tenant ID to the `update` method as follows:
 * `tenantProvider.update(new TenantId())`.
 */


exports.TenantIds = TenantIds;

var TenantProvider = /*#__PURE__*/function () {
  /**
   * Creates a new `TenantProvider` configured with the passed tenant ID.
   *
   * The argument may be omitted but until the `_tenantId` is assigned some non-default value, the
   * application is considered single-tenant.
   *
   * @param {?TenantId} tenantId the ID of the currently active tenant
   */
  function TenantProvider(tenantId) {
    _classCallCheck(this, TenantProvider);

    if (tenantId) {
      TenantProvider._checkIsValidTenantId(tenantId);

      this._tenantId = tenantId;
    }
  }
  /**
   * @param {!TenantId} tenantId the ID of the currently active tenant
   */


  _createClass(TenantProvider, [{
    key: "update",
    value: function update(tenantId) {
      TenantProvider._checkIsValidTenantId(tenantId);

      this._tenantId = tenantId;
    }
    /**
     * Returns the currently active tenant ID.
     *
     * @return {TenantId}
     */

  }, {
    key: "tenantId",
    value: function tenantId() {
      return this._tenantId;
    }
    /**
     * Checks that the passed object represents a `TenantId` message.
     *
     * @param {!object} tenantId the object to check
     * @private
     */

  }], [{
    key: "_checkIsValidTenantId",
    value: function _checkIsValidTenantId(tenantId) {
      if (!tenantId || !(0, _typedMessage.isProtobufMessage)(tenantId) || _typedMessage.Type.forMessage(tenantId).url().value() !== 'type.spine.io/spine.core.TenantId') {
        throw new Error("Expected a valid instance of the 'TenantId' message." + "The '".concat(tenantId, "' was passed instead."));
      }
    }
  }]);

  return TenantProvider;
}();

exports.TenantProvider = TenantProvider;
//# sourceMappingURL=tenant.js.map